import { InteractionWorkspaceProps } from "./types";
import { useStyle } from "./style";
import { MessagingChatInteractionContent } from "@/components/molecules/interactionWorkspace";

export const MessagingChatHistoryInteractionContent = (
	props: InteractionWorkspaceProps
) => {
	const { historyItem } = props;
	const classes = useStyle();

	return (
		<div className={classes.conversation}>
			<MessagingChatInteractionContent
				hideSendBox
				isHistory
				interactionId={historyItem.interactionId}
				type={historyItem.type}
			/>
		</div>
	);
};
